const common = {
  "nav.home": "الرئيسية",
  "nav.advantages": "المميزات",
  "nav.testimonials": "آراء العملاء",
  "nav.pricing": "الأسعار",
  "nav.contact": "اتصل بنا",
  "nav.dashboard": "لوحة التحكم",
  "nav.signIn": "تسجيل الدخول",
  "nav.logout": "تسجيل الخروج",
  "nav.toggleMenu": "فتح القائمة",
  "nav.profile": "الملف الشخصي",
  "nav.language": "اللغة",
  "footer.tagline": "ابقَ في المقدمة",
  "footer.description": "احصل على تحديثات حول الميزات الجديدة ورؤى الصناعة ونصائح لعرض مزاياك بفعالية.",
  "footer.newsletter.placeholder": "اكتب رسالتك...",
  "footer.newsletter.subscribe": "واتساب",
  "footer.navigation": "التنقل",
  "footer.contact": "اتصل بنا",
  "footer.location": "الموقع",
  "footer.privacy": "الخصوصية",
  "footer.terms": "الشروط",
  "footer.copyright": "© 2026 Wyzon. جميع الحقوق محفوظة.",
  "footer.address": "123 طريق الابتكار، سان فرانسيسكو، كاليفورنيا 94102",
  "footer.phone": "+20 109 9289 280",
  "footer.email": "sales@debugin.com",
  "loading": "جاري التحميل...",
  "error.generic": "حدث خطأ ما",
  "button.tryAgain": "حاول مرة أخرى",
  "button.back": "رجوع",
  "button.submit": "إرسال",
  "button.cancel": "إلغاء",
  "language.en": "English",
  "language.ar": "العربية",
  "direction": "rtl",
  "plan.basic": "أساسية",
  "plan.pro": "برو",
  "plan.enterprise": "متقدمة",
};

export default common;